import { Colors, Metrics, Typography } from "../../resources";
import { IIconButtonModal, Orientation } from "../../types";
import React, { useState } from "react";
import { SButton, SSpacer, STextInput } from "../atoms";
import { StyleSheet, Text, View } from "react-native";

import { Toaster } from "@density/ui";
import { noop } from "lodash";

interface IProps extends IIconButtonModal {
  selected: number;
  onSave: (value: string) => void;
}

const SEditCapacityModal: React.FC<IProps> = ({
  selected,
  onSave,
  onCancel = noop,
}) => {
  const [capacity, setCapacity] = useState<string>("");

  const onChangeCapacity = (text: string) => {
    if (/^\d+$/.test(text) || text === "") {
      setCapacity(text);
    }
  };

  const onSubmitEditing = (value: {
    nativeEvent: {
      text: string;
      eventCount: number;
      target: string;
    };
  }) => {
    onSave(value.nativeEvent.text);
  };

  const _onLocalSave = (capacity: string) => {
    onSave(capacity);
    onCancel();
    Toaster.showToast({
      text: "Bulk safe capacity change successful",
      timeout: 2000,
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={{ alignItems: "center", flexDirection: "row" }}>
          <Text style={styles.titleText}>{"Edit Safe % on  "}</Text>
          <View
            style={{
              height: 24,
              width: 24,
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 12,
              backgroundColor: Colors.yellow300,
              paddingHorizontal: 4,
            }}
          >
            <Text style={styles.titleText}>{selected}</Text>
          </View>
          <Text style={styles.titleText}>{"  selected spaces"}</Text>
        </View>
      </View>
      <View style={styles.content}>
        <STextInput
          placeholder={""}
          value={capacity}
          accessoryIcon={false}
          textStyle={{
            ...Typography.bodyNumber,
            color: Colors.grey900,
            width: Metrics.size86 - 2 * Metrics.padding8,
            height: 32,
          }}
          onChangeText={onChangeCapacity}
          onSubmitEditing={onSubmitEditing}
          onFocus={() => {}}
        />
      </View>

      <View style={styles.footer}>
        <SButton
          onPress={onCancel}
          style={{ height: Metrics.iconLarge, width: 64 }}
          color={Colors.blue700}
          backgroundColor={Colors.white}
          textColor={Colors.blue700}
        >
          Cancel
        </SButton>
        <SSpacer space={Metrics.padding8} type={Orientation.Horizontal} />
        <SButton
          onPress={() => _onLocalSave(capacity)}
          style={{ height: Metrics.iconLarge, width: 64 }}
        >
          Save
        </SButton>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    width: 283,
    height: 161,
    left: 0,
    top: Metrics.size32 + 2,
    backgroundColor: Colors.white,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: Colors.grey200,
    shadowColor: "#03082e",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  header: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.grey000,
    height: 48,
  },
  titleText: {
    ...Typography.title,
    color: Colors.grey900,
    textTransform: "uppercase",
  },
  content: {
    height: 64,
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 16,
  },
  footer: {
    flexDirection: "row",
    height: 48,
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: 8,
    borderTopWidth: 1,
    borderColor: Colors.grey200,
  },
});

export default SEditCapacityModal;
